import type {
  CardsResponse,
  DiagnosisResultResponse,
} from '@/apis/repositories/models/derek'
import type { DiagnosisSummary, DiagnosisAnalysis } from '@/types/app'
import { formatDiagnosisType } from '@/libs/utilities/formatDiagnosisResult'

const parseAnalysisItem = <U extends keyof DiagnosisAnalysis>({
  rank,
  myValue,
  ...rest
}: CardsResponse[keyof CardsResponse]): DiagnosisAnalysis[U] =>
  ({
    ...rest,
    userValue: myValue,
    rank: rank ?? undefined,
  }) as unknown as DiagnosisAnalysis[U]

export const createDiagnosisSummary = ({
  personality,
  cards,
}: DiagnosisResultResponse): DiagnosisSummary => ({
  analysis: {
    annualIncome: parseAnalysisItem<'annualIncome'>(cards.annual_income),
    annualSaving: parseAnalysisItem<'annualSaving'>(cards.saving_annual),
    monthlyRentCost: parseAnalysisItem<'monthlyRentCost'>(
      cards.monthly_rent_cost
    ),
    investment: parseAnalysisItem<'investment'>(cards.investment),
    monthlyInsurance: parseAnalysisItem<'monthlyInsurance'>(
      cards.monthly_insurance
    ),
  },
  result: {
    personality: {
      type: formatDiagnosisType(personality.id),
      title: personality.title,
      description: personality.description,
    },
  },
})
